<template>
  <cms-alert-modal
    v-if="!hideAlerts.modal && isAlertModal && openModal"
    :globals="globals"
    :alert-content="activeLegacyAlert.content"
    :translations="componentTranslations.alert_modal"
    @close="closeAlertModal"
  />
  <cms-alert-banner
    v-else-if="!hideAlerts.banner && isAlertBanner"
    :globals="globals"
    :alert-content="activeLegacyAlert.content"
  />
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';

defineOptions({ name: 'LegacyAlert' });

const props = defineProps({
  activeAlerts: {
    type: Array,
    default: () => [],
  },
  hideAlerts: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['close']);

const store = useStore();

const openModal = ref(false);

const globals = computed(() => store.state.globals);
const componentTranslations = computed(() => store.state.translation.componentTranslations);

const activeLegacyAlert = computed(() => (props.activeAlerts.length > 0 ? props.activeAlerts[0] : {}));

const isAlertModal = computed(
  () => Object.keys(activeLegacyAlert.value).length > 0 && Boolean(activeLegacyAlert.value.light_box),
);

const isAlertBanner = computed(
  () => Object.keys(activeLegacyAlert.value).length > 0 && !activeLegacyAlert.value.light_box,
);

onBeforeMount(() => {
  openModal.value = Object.keys(activeLegacyAlert.value).length > 0 && isAlertModal.value && !props.hideAlerts.modal;
});

function closeAlertModal(closeObject) {
  openModal.value = false;
  emit('close', {
    alertId: 'legacy',
    closedByKeyboard: closeObject.closedByKeyboard,
  });
}
</script>
